/** A palette's colors as a strip of small squares, for pickers and lists. */
export function PaletteSwatches({
  colors,
  size = 'sm',
}: {
  colors: readonly string[];
  size?: 'sm' | 'md';
}) {
  const box = size === 'sm' ? 'h-3 w-3' : 'h-5 w-5';
  return (
    <span className="inline-flex shrink-0 overflow-hidden rounded-sm border">
      {colors.map((color, index) => (
        <span
          key={`${color}-${index}`}
          className={box}
          style={{ backgroundColor: color }}
          aria-hidden
        />
      ))}
    </span>
  );
}
